import { render, staticRenderFns } from "./ArticleSettings.vue?vue&type=template&id=4da3dfd6"
import script from "./ArticleSettings.vue?vue&type=script&lang=js"
export * from "./ArticleSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports